import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';

const container = document.getElementById('root');

if (container === null) {
  // Сообщение разработчику о сломанной сборке, а не текст интерфейса: до диспетчера
  // оно не доходит — приложение в этот момент не отрисовано. Поэтому английский,
  // как и в остальных технических исключениях.
  throw new Error('Root element #root is missing in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
